import { PlusIcon } from '@heroicons/react/24/outline'
import type { AddBoxButtonProps } from './types'

export function AddBoxButton({ onAdd, disabled }: AddBoxButtonProps) {
  return (
    <button
      onClick={onAdd}
      disabled={disabled}
      data-testid="add-box-button"
      data-tour="add-box-button"
      className="w-full px-4 py-3 bg-gray-800/40 hover:bg-gray-700/40 disabled:bg-gray-800/20
                 border border-gray-700 disabled:border-gray-800 rounded-lg
                 text-gray-300 disabled:text-gray-600 text-sm font-medium
                 flex items-center justify-center gap-2
                 transition-colors duration-200
                 disabled:cursor-not-allowed"
      aria-label={disabled ? 'Maximum boxes reached' : 'Add narrative box'}
    >
      <PlusIcon className="w-5 h-5" />
      <span>Add Box</span>
    </button>
  )
}
